export default "__VITE_ASSET__Cslvqo1t__"